import $ from 'jquery';
import { $root } from './variables';
import { lazyLoadInstance } from './auxilaries';
import jQueryBridget from 'jquery-bridget';
import masonry from 'masonry-layout';

jQueryBridget('masonry', masonry, $);
// ajax loadmore + masonry 
if ($('.js__loadmore_posts').length !== 0) {

  let $postContainer = $('.js__post_container');
  $postContainer.masonry({
    columnWidth: '.post',
    itemSelector: '.post',
    horizontalOrder: true,
    resize: true,
    percentPosition: true,
    gutter: 16,
    stagger: 0,
    transitionDuration: 0
  });

  $('.js__loadmore_posts').on('click', function (ev) {
    ev.preventDefault();

    loadmore_posts($(this));
  });
}

export function loadmore_posts(button = null) {
  let $button = button ?? $('.js__loadmore_posts');
  let cta_text = $button.data('title');
  let loading_text = $button.data('title-loading');

  let query_data = {
    'action': 'loadmore',
    'query': cw_loadmore_params.posts,
    'page': cw_loadmore_params.current_page
  };

  $.ajax({
    url: cw_loadmore_params.ajaxurl, // AJAX handler
    data: query_data,
    type: 'POST',
    beforeSend: () => {
      $button.text(loading_text); // change the button text, you can also add a preloader image
    },
    success: (data) => {
      if (data) {
        $button.text(cta_text); // .prev().append(data); // insert new posts

        cw_loadmore_params.current_page++;
        let $elems = $(`${data}`);

        $('.js__post_container').append($elems).masonry('appended', $elems);
        let value = $('.js__news_select').val();
        if (value !== "newest") {
          let class_selector = ".js__" + value;
          $('.post').addClass('hidden');
          $(class_selector).removeClass('hidden');
        } else {
          $('.post').removeClass('hidden');
        }
        $root.animate({ scrollTop: '+=1px' }, 10);

        $('.post').removeClass('opacity-0');
        lazyLoadInstance.update();

        let max_possible_posts = (parseInt(query_data.page) + 1) * 4;

        let visible_posts = $('.post').not(".hidden");

        if (visible_posts.length < max_possible_posts && !(cw_loadmore_params.current_page == cw_loadmore_params.max_page)) {
          loadmore_posts($button);
        }

        $('.js__post_container').masonry();

        if (cw_loadmore_params.current_page == cw_loadmore_params.max_page)
          $button.remove();

      } else {
        $button.remove();
      }
    }
  });
}